// extracted by mini-css-extract-plugin
export default {"item":"TaskNavigationLink_item__Gs119","count":"TaskNavigationLink_count__3gWhc","name":"TaskNavigationLink_name__yUinF","chevronRight":"TaskNavigationLink_chevronRight__NtcGV"};